import React, { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import FloatingWhatsApp from '../common/FloatingWhatsApp'

function PublicLayout() {
  useEffect(() => {
    const href = '/LOGODK.png'
    let link = document.querySelector('link[rel="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.setAttribute('rel', 'icon')
      document.head.appendChild(link)
    }
    link.setAttribute('href', href)
  }, [])
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white/80 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex items-center justify-center gap-3">
            <img src="/LOGODK.png" alt="Dkard" className="w-6 h-6" />
            <span className="text-sm font-semibold tracking-wide text-gray-900">Dkard</span>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <FloatingWhatsApp />
      <footer className="bg-white/80 backdrop-blur-sm border-t">
        <div className="max-w-7xl mx-auto px-4 py-4 text-center text-sm text-gray-600">
          <div className="inline-flex items-center justify-center gap-2">
            <img src="/LOGODK.png" alt="Dkard" className="w-5 h-5" />
            <span>¿Quieres tu propia Dkard?</span>
            <Link to="/" className="text-blue-600 hover:text-blue-800">Conoce Dkard</Link>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default PublicLayout
